module.exports = __webpack_public_path__ + "f5b79d22edb7a3c81c171b46fbc5db67.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/destructive_abilities-1050.jpg
// module id = 245
// module chunks = 0